import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GuardianInviteGuardService } from './guardian-invite/guardian-invite-guard.service'
import { GuardianInviteComponent } from './guardian-invite/guardian-invite.component'
import { SetupMembershipComponent } from './setup-membership/setup-membership.component'

const routes: Routes = [
  { path: '', redirectTo: 'account', pathMatch: 'full', },
  {
    path: 'account',
    loadChildren: () => import('./create-account/create-account.module')
      .then(m => m.CreateAccountModule)
  },
  {
    path: 'guardian-invite/:id/accept',
    canActivate: [
      GuardianInviteGuardService
    ],
    component: GuardianInviteComponent
  },
  {
    path: 'household',
    loadChildren: () => import('./create-household/create-household.module')
      .then(m => m.CreateHouseholdModule)
  },
  {
    path: 'membership',
    component: SetupMembershipComponent
  },
  {
    path: 'mfa-onboarding',
    loadChildren: () => import('./mfa-onboarding/mfa-onboarding.module')
      .then(m => m.MfaOnboardingModule)
  },
  {
    path: '**',
    redirectTo: 'account',
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
